import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export const internalRoleNames = [
  'MSFES User',
  'MSFES Office Staff',
  'MSFES Sales'
]
export const useTenantOrGlobalAdmin = () => {
  const user = useSelector((appState) => appState?.users?.user ?? null)

  const {
    isGlobalAdmin,
    isTenantAdmin,
    isInAnOfficerRole,
    isTrainerAdmin,
    isCurrentlyGlobalAdmin,
    isInternalRole,
    actingRole,
    tenant
  } = useMemo(() => {
    let isGlobalAdmin = false
    let isTenantAdmin = false
    let isCurrentlyGlobalAdmin = false
    let isInternalRole = false
    let isTrainerAdmin = false
    let isInAnOfficerRole = false
    const actingRole = user?.acting_role
    const tenant = user?.current_tenant

    if (actingRole === 'MSFES User') {
      isGlobalAdmin = true
    }

    if (internalRoleNames.includes(actingRole)) {
      isInternalRole = true
    }
    if (actingRole === 'MSFES User' && !user.tenant_record) {
      isCurrentlyGlobalAdmin = true
    }
    if (actingRole === 'Tenant Admin') {
      isTenantAdmin = true
    }
    if (actingRole === 'Trainer Admin') {
      isTrainerAdmin = true
    }

    if (
      actingRole === 'Tenant Admin' ||
      actingRole === 'Deputy Fire Chief' ||
      actingRole === 'Assistant Fire Chief' ||
      actingRole === 'Battalion Fire Chief'
    ) {
      isInAnOfficerRole = true
    }

    const returnObject = {
      isGlobalAdmin,
      isInternalRole,
      isTenantAdmin,
      isInAnOfficerRole,
      isTrainerAdmin,
      isCurrentlyGlobalAdmin,
      actingRole,
      tenant
    }

    return returnObject
  }, [user])

  return {
    isGlobalAdmin,
    isTenantAdmin,
    isInAnOfficerRole,
    isTrainerAdmin,
    isCurrentlyGlobalAdmin,
    isInternalRole,
    actingRole,
    tenant,
    user
  }
}
